import React, { useEffect, useRef } from "react";

function CaseIcon({ Dyn, width, height, isActive }) {
    const svg = useRef();

    useEffect(() => {
        // Set viewBox based on the path's width and height
        const _svg = svg.current;
        const { xMin, xMax, yMin, yMax } = [..._svg.children].reduce(
            (acc, el) => {
                const { x, y, width, height } = el.getBBox();
                if (!acc.xMin || x < acc.xMin) acc.xMin = x;
                if (!acc.xMax || x + width > acc.xMax) acc.xMax = x + width;
                if (!acc.yMin || y < acc.yMin) acc.yMin = y;
                if (!acc.yMax || y + height > acc.yMax) acc.yMax = y + height;
                return acc;
            },
            {}
        );
        const viewbox = `${xMin} ${yMin} ${xMax - xMin} ${yMax - yMin}`;
        _svg.setAttribute("viewBox", viewbox);
    }, []);

    let path = Dyn.dataSet?.getCustomCaseIcon();
    if (!path) {
        path = new Dyn.IconStyler().calcCirclePath(40 * 0.5, 20, 15);
    }

    return (
        <svg
            ref={svg}
            style={{ display: "inline" }}
            width={width || 30}
            height={height || 30}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill={isActive ? "#fff" : "#1d4cbc"} d={path}></path>
        </svg>
    );
}

export default CaseIcon;
